import Honeybadger from "@honeybadger-io/js"

import { AppError } from "./AppError"

interface GraphQLResponseErrorArgs {
  message: string
  operationName?: string
  extensions?: Record<string, unknown>
}

export class GraphQLResponseError extends AppError {
  operationName?: string

  extensions?: Record<string, unknown>

  constructor({
    message,
    operationName,
    extensions
  }: GraphQLResponseErrorArgs) {
    super(message)
    this.name = "GraphQLResponseError"
    this.operationName = operationName
    this.extensions = extensions
  }

  notify() {
    const code = this.extensions?.code
    Honeybadger.notify(this, {
      name: this.name,
      message: this.message,
      stack: this.stack,
      fingerprint: [
        this.name,
        this.operationName ?? "",
        typeof code === "string" ? code : this.message
      ].join(":"),
      context: {
        operationName: this.operationName,
        extensions: this.extensions
      }
    })
  }
}
